import { fetchClient } from '../lib/openapi-query';

export interface VariantL10n {
  variantId: number;
  locale: string;
  name: string;
  description: string | null;
  measurementUnit: string;
  imageUrl: string | null;
  minimumRestockThreshold: number;
  usageInstructions: string | null;
  nutritionalFacts: string | null;
  recommendedDosage: string | null;
  storageRequirements: string | null;
  userDailyDose: string;
  capacity: string;
  maximumDailyDose: number;
  maximumDailyDoseUnit: string;
  timeSpacingRequirements: string | null;
  packaging: string | null;
  benefits: string | null;
  effects: string | null;
  intendedPurpose: string | null;
  ingredients: string | null;
  isActive: boolean;
  isPromoItem: boolean;
  isConsumable: boolean;
  sku: string;
  familyId: number;
  productType: string;
  createdAt: string;
  updatedAt: string;
  previewUrl: string | null;
}

export interface UpdateVariantField {
  variantId: number;
  locale: string;
  field: string;
  value: string | number | boolean | null;
}

export const dataReviewApi = {
  getLocales: async (realmId?: number): Promise<string[]> => {
    const queryParams: Record<string, string> = {};
    if (realmId !== undefined) {
      queryParams.realmId = realmId.toString();
    }

    const response = await fetchClient.GET('/products/data-review/locales' as any, {
      params: Object.keys(queryParams).length > 0 ? { query: queryParams as any } : undefined
    });

    if (response.error) {
      throw new Error('Failed to fetch available locales');
    }

    return response.data as unknown as string[];
  },

  getVariants: async (locale: string): Promise<VariantL10n[]> => {
    const response = await fetchClient.GET('/products/data-review/variants' as any, {
      params: {
        query: { locale }
      }
    });

    if (response.error) {
      throw new Error('Failed to fetch variants for data review');
    }

    return response.data as unknown as VariantL10n[];
  },

  updateVariantField: async (data: UpdateVariantField): Promise<{ success: boolean }> => {
    const response = await fetchClient.PATCH('/products/data-review/variant' as any, {
      body: data as any
    });

    if (response.error) {
      throw new Error('Failed to update variant field');
    }

    return response.data as unknown as { success: boolean };
  }
};
